module.exports = __webpack_public_path__ + "img/3.594de12d.png";